import { styled } from '@mui/material/styles';

const ButtonWrapper = styled('div')(({ theme }) => ({
    margin: theme.spacing(1),
    position: 'relative',
}));

export default ButtonWrapper;
